import {
  CREATE_VENDOR,
  VIEW_VENDOR,
  UPDATE_VENDOR,
  DELETE_VENDOR,
  LIST_OF_VENDOR,
} from "./ApiRoutes";
import { authData } from "./services";

export const createVendor = async (data: object) => {
  const response = await authData.post(CREATE_VENDOR, data);
  return response?.data;
};

export const updateVendor = async (id: number, data: object) => {
  const response = await authData.put(`${UPDATE_VENDOR}${id}`, data);
  return response?.data;
};

export const listOfVendor = async (data: object) => {
  const response = await authData.post(LIST_OF_VENDOR, data);
  return response?.data;
};

export const viewVendor = async (id: number) => {
  const response = await authData.get(`${VIEW_VENDOR}${id}`);
  return response?.data;
};

export const deleteVendor = async (id: number) => {
  const response = await authData.delete(`${DELETE_VENDOR}${id}`);
  return response?.data;
};
